var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderlogo = function SvgHeaderlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 4.36314C33.0865 3.0577 35.1294 2.27203 37.3587 2.27203C42.4073 2.27203 46.5 6.30147 46.5 11.272C46.5 16.2426 42.4073 20.272 37.3587 20.272C35.3137 20.272 33.4255 19.6109 31.9026 18.4938",
    stroke: "#E77CCF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.29208C19.0225 3.02924 17.1366 2.27203 15.0819 2.27203C10.3423 2.27203 6.5 6.30147 6.5 11.272C6.5 16.2426 10.3423 20.272 15.0819 20.272C17.1366 20.272 19.0225 19.5148 20.5 18.252",
    stroke: "#2F80ED",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 22.2721C31.815 21.5639 35.8183 21.0112 38.4307 21.0112C43.409 21.0112 47.9909 22.4157 51.6291 24.7721",
    stroke: "#E77CCF",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25.5134C5.78944 22.7132 10.7893 21.0112 16.2696 21.0112C19.1857 21.0112 21.9659 21.4931 24.5 22.366",
    stroke: "#2F80ED",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9401 10.9697C34.9401 15.964 30.988 19.9394 26.2022 19.9394C21.4165 19.9394 17.4644 15.964 17.4644 10.9697C17.4644 5.97539 21.4165 2 26.2022 2C30.988 2 34.9401 5.97539 34.9401 10.9697Z",
    stroke: "#BB6BD9",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 30.453C11.8426 26.1508 19.1311 22.272 26.7019 22.272C34.2023 22.272 41.2824 25.9111 45.5 30.215",
    stroke: "#BB6BD9",
    strokeWidth: 4
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/headerlogo.e7a479c0.svg";
export { ForwardRef as ReactComponent };